// extracted by mini-css-extract-plugin
export default {"table":"styles_table__HqhsO","labelCell":"styles_label-cell__R0fGe","noAccess":"styles_no-access__yRkuO","checkCell":"styles_check-cell__iXkyu"};